module.exports = __webpack_public_path__ + "media/svg-new/dead-sign-d043e7b0.svg";